import { LogCategory } from "Enumerations";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useLogging } from "Shared/Hooks";

import { Spinner } from "@fluentui/react-components";

import { RenderingStatus } from "../../../Enumerations/RenderingStatus";
import { useM365PulseInfiniteScrollStyles } from "./M365PulseInfiniteScroll.styles";
import { InfiniteScrollProps } from "./M365PulseInfiniteScroll.types";

const M365PulseInfiniteScrollBase = (props: InfiniteScrollProps) => {
    const { onBottomVisible } = props;
    const { trackException } = useLogging(LogCategory.Core);
    const classNames = useM365PulseInfiniteScrollStyles();

    const { ref, inView } = useInView({ threshold: 1 });

    useEffect(() => {
        try {
            if (inView && onBottomVisible) {
                onBottomVisible();
            }
        } catch (ex) {
            trackException("8b7f6464-beba-4071-97b7-e272d730dbf1", ex, "Exception happens when using calling the onEndReached function in Infinite Scroll");
        }
    }, [inView, onBottomVisible, trackException]);

    return (
        <>
            {props.children}
            <div ref={ref}></div>
            {props.loadingStatus === RenderingStatus.Waiting && <Spinner className={classNames.spinner} aria-busy="true" aria-label="Loading Content" />}
        </>
    );
};

export const M365PulseInfiniteScroll = observer(M365PulseInfiniteScrollBase);
